import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce } from 'react-use'
import { Header, ListingTemplate } from '../../../views/components'
import BillingIcon from '../../../views/components/atoms/Icons/Doc/InvoiceFill'
import { apiStateSelectors } from '../../api/apiState'
import { accountingApiEvents, accountingApiSelectors } from '../../api/accounting'
import { agencyApiEvents } from '../../api/agency'
import NextInvoiceNumber from './NextInvoiceNumber/NextInvoiceNumber'
import BillingSettingsTable from './BillingSettingsTable/BillingSettingsTable'
import { DiscountTarget } from './DiscountPanel/DiscountPanel'
import styles from './AdminBillingContent.module.scss'

type TProps = {
  onEditCounter: () => void
  onAddAgency: () => void
  onEditDiscounts: (target: DiscountTarget) => void
}

const AdminBillingContent = ({ onEditCounter, onAddAgency, onEditDiscounts }: TProps) => {
  const dispatch = useDispatch()

  useEffectOnce(() => {
    dispatch(accountingApiEvents.billingAgencySettings_request())
    // The agency picker needs the full listing, which nothing else on this
    // page fetches.
    dispatch(agencyApiEvents.agencyListing_request())
  })

  const settings = useSelector(accountingApiSelectors.getBillingAgencySettings)
  const isLoading = useSelector(state =>
    apiStateSelectors.isLoading(state)([accountingApiEvents.billingAgencySettings_request]),
  )

  return (
    <ListingTemplate
      loading={isLoading && !settings}
      Header={<div style={{ minHeight: '50px' }}></div>}
      Body={
        <div className={styles.root}>
          <Header icon={<BillingIcon />} text="Billing" />
          <NextInvoiceNumber
            lastUsed={settings?.lastBillingInvoiceNumber ?? null}
            distinctValues={settings?.distinctValues ?? null}
            loading={isLoading}
            onEdit={onEditCounter}
          />
          <BillingSettingsTable
            settings={settings?.settings ?? []}
            counter={settings?.lastBillingInvoiceNumber ?? null}
            loading={isLoading}
            onAddAgency={onAddAgency}
            onEditDiscounts={onEditDiscounts}
          />
        </div>
      }
    />
  )
}

export default AdminBillingContent
